// changes

const getThresholdValueFlu = (level) => {
  switch (level) {
    case 1:
      return {
        threshold: 'Minimal',
        color: '#218371',
        OutlineColor: '#218371',
      }
   
    case 2:
      return {
        threshold: 'Low',
        color: '#6CB2A2',
        OutlineColor: '#6CB2A2',
      }
   
    case 3:
      return {
        threshold: 'Moderate',
        color: '#C6E8DF',
        OutlineColor: '#15A796',
      }
    case 4:
      return {
        threshold: 'Moderate',
        color: '#FFFFF0',
        OutlineColor: '#AD8D01',
      }
   

    case 5:
      return {
        threshold: 'High',
        color: '#FEC8B9',
        OutlineColor: '#FF1A1A',
      }
    case 6:
      return {
        threshold: 'High',
        color: '#F3927E',
        OutlineColor: '#FF1A1A',
      }
  
    case 7:
      return {
        threshold: 'Very High',
        color: '#DF5A42',
        OutlineColor: '#DF5A42',
      }
    case 8:
      return {
        threshold: 'Very High',
        color: '#C40000',
        OutlineColor: '#C40000',
      }
 

    default:
      return {
        threshold: 'No Data',
        color: '#E5E5E6',
        OutlineColor: '#7D7F81',
      }
  }
}

export default getThresholdValueFlu